import { render, staticRenderFns } from "./PaginaAdminDepartamentos.vue?vue&type=template&id=e2dd87b4&lang=es"
import script from "./PaginaAdminDepartamentos.vue?vue&type=script&lang=js"
export * from "./PaginaAdminDepartamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports